/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoteHistory/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronRight from 'DesignSystem/Svgs/Tysiav2ChevronRight/index'
import VerticalTimeline from 'DesignSystem/VerticalTimeline/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoteHistory({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note/ViewNoteDialog/NoteHistory"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventScheduleNoteHistoryValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'schedule_note.history',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="right"
 offsetMainAxis={0}
 offsetCrossAxis={0}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="NoteHistory.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-hYao3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="View note history"
/>
<div
  data-testid="NoteHistory.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
/>
<Tysiav2ChevronRight
  viewPath={`${viewPath}/Tysiav2ChevronRight`}
 fill2="#513C06"
/>
</div>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<div
  data-testid="NoteHistory.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-2-hYao3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-3-hYao3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-4-hYao3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-5-hYao3': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-hYao3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-7-hYao3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-8-hYao3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-hYao3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-10-hYao3': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<VerticalTimeline
  viewPath={`${viewPath}/VerticalTimeline`}
 data="event.schedule_note.history"
 history={eventScheduleNoteHistoryValueData}
 dotColor={dtColorsNeutral600}
 lineColor={dtColorsNeutral500}
 tagType="noteYellow"
/>
</div>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}